export const defaultPage: number = 1;
export const defaultLimit: number = 10;
export const initialList = {
    data: [],
    meta: { totalRecords: 0, limit: defaultLimit, page: 1, totalPages: 1 }
};
export const pageSizeOptions: string[] = ['10', '15', '25', '50', '100'];
export const showSizeChanger: boolean = true;
export const defaultTotalPages: number = 1;
export const defaultTotalRecord: number = 0;
export const defaultSort: string = 'desc';
export const defaultOrder: string = 'updatedAt';
export const defaultParamList: any = {
    limit: defaultLimit,
    orderBy: defaultOrder,
    page: defaultPage,
    showAll: false,
    sort: defaultSort,
}
export const messageFailedRemove: string = "Failed to delete data";
export const messageFailedGetList = (name: string) => `Failed to get ${name} list`;
export const messageFailedGetOne = (name: string) => `Failed to get ${name} data`;
export const messageFailedSaveData: string = "Failed to save data";
export const messageSuccessSaveData: string = "Data has been save!";
export const messageSuccessRemoveData: string = "Data has been removed!";



// WEBPACK FOOTER //
// ./src/helpers/constant.tsx